import React, { useState, useEffect  } from 'react';
import { FaUser, FaEnvelope, FaPhoneAlt, FaMapMarkedAlt, FaLock } from 'react-icons/fa';
import axios from '../../axiosInstance'; // Assuming you have axios setup
import './ReporterRegistrationForm.css';
import { useNavigate } from 'react-router-dom';  // Correct import for useNavigate
import Logo from '../../images/logo2.jpg';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ReporterRegistrationForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    gender: "",
    district: "",
    state: "",
    pincode: "",
    address: "",
    password: "",
    confirmPassword: "",
    profileImage: null,
    termsAccepted: false,
    channel: "", // Added channel field
  });

  const [districts, setDistricts] = useState([]);
  const [error, setError] = useState('');
  const stateDistrictMap = {
    "Tamil Nadu": [
      'Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri',
      'Dindigul', 'Erode', 'Kallakurichi', 'Kancheepuram', 'Kanniyakumari', 'Karur', 'Krishnagiri',
      'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai',
      'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 'Tenkasi', 'Thanjavur', 'Theni',
      'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupattur', 'Tiruppur', 'Tiruvallur',
      'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Viluppuram', 'Virudhunagar'
    ],
    Pondicherry: ["Pondicherry", "Karaikal", "Mahe", "Yanam"],
  };
  const navigate = useNavigate();  // Initialize the navigate function
  const [channelOptions, setChannelOptions] = useState([]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.match(/^[A-Za-z]+$/)) {
      newErrors.firstName = "First name must contain only alphabets.";
    }

    if (!formData.lastName.match(/^[A-Za-z]+$/)) {
      newErrors.lastName = "Last name must contain only alphabets.";
    }

    if (!formData.mobileNumber.match(/^[6-9]\d{9}$/)) {
      newErrors.mobileNumber = "Mobile number must be 10 digits and start with 6-9.";
    }

    if (!formData.email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (formData.pincode && !formData.pincode.match(/^\d{6}$/)) {
      newErrors.pincode = "Pincode must be 6 digits.";
    }

    if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long.";
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    if (!formData.termsAccepted) {
      newErrors.termsAccepted = "You must accept the terms and conditions.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  useEffect(() => {
    // Get channels from localStorage if available
    const channels = localStorage.getItem("channels");
    if (channels) {
      console.log("Channels from localStorage:", channels);
      setChannelOptions(JSON.parse(channels)); // Parse and set channels if available in localStorage
    } else {
      // Fallback if no channels are in localStorage
      setChannelOptions([ 
        'No channels avaliable'
      ]);
    }
  }, []);

  const [errors, setErrors] = useState({});
  const [reporterId, setReporterId] = useState(null);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "state") {
      const selectedDistricts = stateDistrictMap[value] || [];
      setFormData((prevData) => ({
        ...prevData,
        state: value,
        district: "", // Reset district when state changes
      }));
      setDistricts(selectedDistricts);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };
  const handleFileChange = (e) => {
    const { files } = e.target;
    setFormData({ ...formData, profileImage: files[0] });
  };

  const handleSubmit = (e) => {

    e.preventDefault();
    if (!validateForm()) {
      return; // Do not proceed if validation fails
    }


    setError('');
    const data = new FormData();

    // Add form fields except the profile image to FormData
    Object.keys(formData).forEach((key) => {
      if (key !== "profileImage" && formData[key] !== null) {
        data.append(key, formData[key]);
      }
    });

    // If there's a profile image, add it as base64
    if (formData.profileImage) {
      data.append("profileImage", formData.profileImage); // Append base64 image data
    }

    axios
      .post('/api/reporter/register', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        console.log('Registration successful:', response.data);
        setReporterId(response.data.reporterId);
        toast.success("Reporter registered successfully.");

        setTimeout(() => {
          navigate("/reporter/login");
        }, 3000); // 3000 milliseconds = 3 seconds

      })
      .catch((error) => {
        console.error('Error registering reporter:', error);

        toast.error("Email or mobile number already in use."); // Show a styled error message

      });
  };

  return (
    <div className='Re-container-main'>

      <div className="Re-container">
        <ToastContainer position="top-right" autoClose={3000} />

        <img src={Logo} alt="My Image" class="Re-Login-image-logo" />
        <h2 className="header-rf">Reporter Registration</h2>
        <form onSubmit={handleSubmit} className="user-form">
          {/* First Name */}
          <div className="form-group">
            <label><i className="fas fa-user"></i> First Name:</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            {errors.firstName && <span className="error">{errors.firstName}</span>}

          </div>

          {/* Last Name */}
          <div className="form-group">
            <label><i className="fas fa-user"></i> Last Name:</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
            {errors.lastName && <span className="error">{errors.lastName}</span>}
          </div>

          {/* Gender */}
          <div className="form-group">
            <label><i className="fas fa-venus-mars"></i> Gender:</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Select your gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            {errors.gender && <span className="error">{errors.gender}</span>}
          </div>

          {/* Profile Image */}
          <div className="form-group">
            <label><i className="fas fa-image"></i> Profile Image:</label>
            <input
              type="file"
              name="profileImage"
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>
          {errors.profileImage && <span className="error">{errors.profileImage}</span>}

          {/* Address */}
          <div className="form-group">
            <label><i className="fas fa-home"></i> Address:</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {errors.address && <span className="error">{errors.address}</span>}

          {/* Mobile Number */}
          {/* Mobile Number */}
          <div className="form-group">
            <label><i className="fas fa-phone"></i> Mobile Number:</label>
            <input
              type="tel"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
              onKeyPress={(e) => {
                if (!/^\d$/.test(e.key)) {
                  e.preventDefault(); // Prevent non-numeric input
                }
              }}
              pattern="[6-9][0-9]{9}" // Ensures the number starts with 6-9 and has exactly 10 digits
              maxLength="10" // Restricts input to 10 characters
              inputMode="numeric" // Displays numeric keyboard on mobile
              title="Mobile number must be 10 digits and start with 6-9."
              required
            />

            {errors.mobileNumber && <span className="error">{errors.mobileNumber}</span>}
          </div>


          {/* Email */}
          <div className="form-group">
            <label><i className="fas fa-envelope"></i> Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <span className="error">{errors.email}</span>}

          </div>

          {/* State */}
          <div className="form-group">
            <label><i className="fas fa-map-marker-alt"></i> State:</label>
            <select
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Select your state</option>
              {Object.keys(stateDistrictMap).map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
            {errors.state && <span className="error">{errors.state}</span>}

          </div>

          {/* District */}
          <div className="form-group">
            <label><i className="fas fa-map-pin"></i> District:</label>
            <select
              name="district"
              value={formData.district}
              onChange={handleChange}
              required
              disabled={!districts.length}
            >
              <option value="" disabled>Select your district</option>
              {districts.map((district) => (
                <option key={district} value={district}>
                  {district}
                </option>
              ))}
            </select>
            {errors.district && <span className="error">{errors.district}</span>}

          </div>

          {/* Channel */}
          <div className="form-group">
            <label><i className="fas fa-tv"></i> Channel:</label>
            <select
              name="channel"
              value={formData.channel}
              onChange={handleChange}
              required
            >
             <option value="" disabled>Select a channel</option>
        {channelOptions.map((channel) => (
          <option key={channel} value={channel}>
            {channel}
          </option>
        ))}
            </select>
            {errors.channel && <span className="error">{errors.channel}</span>}

          </div>


          {/* Pincode */}
          <div className="form-group">
            <label><i className="fas fa-home"></i> Pincode:</label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
            />
            {errors.pincode && <span className="error">{errors.pincode}</span>}

          </div>

          {/* Password */}
          <div className="form-group">
            <label><i className="fas fa-lock"></i> Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {errors.password && <span className="error">{errors.password}</span>}

          </div>

          {/* Confirm Password */}
          <div className="form-group">
            <label><i className="fas fa-lock"></i> Confirm Password:</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            {errors.confirmPassword && <span className="error">{errors.confirmPassword}</span>}

          </div>

          {/* Terms and Conditions */}
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleChange}
                required
              />
              I accept the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
            </label>
            {errors.termsAccepted && <span className="error">{errors.termsAccepted}</span>}

          </div>

          {/* Submit Button */}
          <button type="submit" className="re-btn">
            Register
          </button>


          <button type="button" className="re-btn">
            <Link to="/reporter/login" style={{ color: 'inherit', textDecoration: 'none' }}>
              Login
            </Link>
          </button>

        </form>
      </div>
    </div>
  );
};

export default ReporterRegistrationForm;
